import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

export const updateCutLot = createAsyncThunk(
    '/user/update-cut-lot-with-wastage',
    async (payload) => {
        try {
            const myurl = `${V_URL}/prosafe/update-cut-lot-with-wastage`;
            const response = await axios({
                method: 'put',
                url: myurl,
                data: payload,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN')
                },
            });

            const lot = response.data;

            if (lot.success === true) {
                return lot;
            } else {
                throw new Error(lot);
            }
        } catch (error) {
            toast.error(error.response.data.message);
            return error;
        }
    }
);

const updateCutLotSlice = createSlice({
    name: "updateCutLot",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(updateCutLot.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateCutLot.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(updateCutLot.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default updateCutLotSlice.reducer;